import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-research-seed-money',
  templateUrl: './research-seed-money.component.html',
  styleUrls: ['./research-seed-money.component.scss']
})
export class ResearchSeedMoneyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
